export default function useFormatDate(date, locale = 'en-US', hour12 = true) {
  try {
    return Intl.DateTimeFormat(locale, {
      year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric', second: 'numeric',
      hour12: hour12
    }).format(Date.parse(date));
  } catch (error) {
    // console.error(error);
  }
}
